import { render, staticRenderFns } from "./i-calendar.vue?vue&type=template&id=467f9468&scoped=true&"
import script from "./i-calendar.vue?vue&type=script&lang=js&"
export * from "./i-calendar.vue?vue&type=script&lang=js&"
import style0 from "./i-calendar.vue?vue&type=style&index=0&id=467f9468&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f9468",
  null
  
)

export default component.exports